import React, { useState, useEffect } from 'react';
import "./NutzerAnlegen.css";
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Sidebar from '../../../components/Sidebar/Sidebar';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import { post } from '../../../Script/Session.js';
import { Token } from '../../../Script/Session.js';
import Stylebutton from '../../../components/buttons/stylebutton/Stylebutton.jsx';
import { Autocomplete } from '@mui/joy';
const NutzerAnlegen = () => {
    const navigate = useNavigate();
    const [data, setdata] = useState();
    const [selected,setselected] = useState();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/regionalgruppen");
        setdata(JSON.parse(response));
        console.log(response);
    }, []);


    function submit(event) {
        let name = document.getElementById("nameinput-new-user").value;
        let vorname = document.getElementById("vornameinput-new-user").value;
        let email = document.getElementById("emailinput-new-user").value;
        let body = {};
        body.token = Token.get();
        body.name = name;
        body.vorname = vorname;
        body.email = email;
        if (!selected){
            return;
        }
        body.reggruppe = selected.id;
        let response = post(body, "/createuser");
        if (response == null) {
            alert("Fehler beim Anlegen des Nutzers");
            return;
        }
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "EXISMAIL") {
            alert("Email bereits vergeben");
            return;
        }
        let json = JSON.parse(response);
        if (json.status == "OK") {
            alert("Nutzer erfolgreich angelegt");
            //evtl later
            //navigate("/verwaltung-userprofile/" + json.id);
        }
    }

    return (
        <>
            <head><title>Verwaltung || Nutzer anlegen</title></head>
            <NavigationBar state="adminhome" back="inline" />
            <div className="nutzeranlegen-container">
                <form className="nutzeranlegen-form">
                    <div className="image-div-user-create">
                        <label className="nutzeranlegen-label">Nutzer Anlegen</label>
                    </div>
                    <div className="nutzer-create-line-placeholder"></div>
                    <input id='nameinput-new-user' type="text" className="nutzer-input" placeholder="Name ..." required />
                    <input id='vornameinput-new-user' type="text" className="nutzer-input" placeholder="Vorname ..." required />
                    <input id='emailinput-new-user' type="text" className="nutzer-input" placeholder="Email ..." required />
                    <Autocomplete sx={{ mb: 2, width: "95%", ml: "2%" }}  options={data?.result || []} getOptionLabel={(item) => item.name} 
                    onChange={(e,newv) => setselected(newv)} placeholder='Regionalgruppe' />
                    <Stylebutton type="submit" click={submit} className="nutzer-submit-button" buttonText={"Anlegen"} width={"95%"}></Stylebutton>
                </form>
            </div>




            <Sidebar />
        </>
    );



}
export default NutzerAnlegen;